'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'De dienst is momenteel niet beschikbaar, probeer later opnieuw.',
    NEED_ACTIVE: 'Jouw account {{account}} gebruikt de website voor de eerste keer. Gelieve {{activeLink}} de activatie te voltooien en terug te keren naar deze pagina om verder te gaan',
    GOTO_ACTIVE: 'Nu activeren',
    NOT_ACTIVED: 'De account is niet met succes geactiveerd, gelieve {{activeLink}} om te activatie te voltooien',
    COMPLETE_ACTIVE: 'Activatie bevestigen',
    FORBID_ACTIVE: 'De account wordt niet ondersteund in AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Gelieve in te loggen met een andere account',
    ACTIVE_PAGE: 'Bezoek de activatiepagina'
};